export default "__VITE_ASSET__8d87d64f__"